import { Component, OnInit } from '@angular/core';
import { MenuItem } from './menu-item';
import { Router } from '@angular/router';
import { MenuService } from 'src/app/services/menu.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit {
  userName: string;
  showMenu = true;
  menuItems: MenuItem[] = [];
  userRole = "";
  constructor(private router: Router, private menuService: MenuService,private authService: AuthenticationService) {
    this.menuItems = [];
  }

  ngOnInit() {
    this.userRole = this.authService.getUserRole();
    if (!this.userRole){
      this.showMenu = false;
    }
    this.menuItems = this.menuService.getMenuItems();

    console.log(this.userRole);

  }


  logOut() {
    this.router.navigate(['/login']);
    localStorage.clear();
  }

  navigate(route: string){
    this.router.navigate([route]); 
  }
}


@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class SignedoOutShellComponent extends ShellComponent
{

}
